import Backbone from 'backbone';
import { formatIsoDate } from 'utils/dates';
import Base from 'app/models/base';
import { appUrl } from 'utils/wrappers';

export default Base.extend({
  urlRoot: appUrl('api_keys'),
  defaults: {
    showProduction: false,
  },

  createdAtReadable() {
    // return false if there is no created_at property on this model
    if (!this.get('created_at')) {
      return false;
    }
    return formatIsoDate(this.get('created_at'));
  },
  disableApiKey(callbacks) {
    Backbone.$.ajax({
      type: 'POST',
      url: `${this.urlRoot}/${this.id}/disable`,
      error: deferred => callbacks.afterError(deferred),
      success: () => {
        this.set('active', false);
        callbacks.afterSave();
      },
      complete: callbacks.complete,
    });
  },
  createApiKey(options, callbacks) {
    this.save({
      mode: options.mode,
    }, {
      success: model => callbacks.afterCreateSuccess(model),
      error: callbacks.afterCreateError,
    });
  },
  enableApiKey(callbacks) {
    Backbone.$.ajax({
      type: 'POST',
      url: `${this.urlRoot}/${this.id}/enable`,
      success: () => {
        this.set('active', true);
        callbacks.afterActivateSuccess();
      },
    });
  },
});



// WEBPACK FOOTER //
// ./app/models/api_key.js